import { visit } from 'unist-util-visit';

const GROUP_SIZE = 4;

/**
 * Splits text into word/space spans for opacity-based animations.
 */
export function rehypeAnimatedChunks(options = {}) {
  const { className = 'animated-chunk' } = options;
  let globalGroupIndex = 0;

  return tree => {
    visit(tree, 'text', function visitor(node, index, parent) {
      if (!node.value || !parent) {
        return;
      }

      const tokens = node.value.split(/(\s+)/g);
      const groupedTokens = tokens.reduce(
        (groups, token) => {
          const lastGroup = groups[groups.length - 1];
          if (lastGroup.length < GROUP_SIZE) {
            lastGroup.push(token);
          } else {
            groups.push([token]);
          }
          return groups;
        },
        [[]]
      );

      const newNodes = [];

      groupedTokens.forEach(group => {
        newNodes.push({
          type: 'element',
          tagName: 'span',
          properties: {
            className: [className],
            style: `--word-index: ${globalGroupIndex};`,
          },
          children: [{ type: 'text', value: group.join('') }],
        });

        globalGroupIndex += 1;
      });

      parent.children.splice(index, 1, ...newNodes);

      // eslint-disable-next-line consistent-return
      return index + newNodes.length;
    });
  };
}
